import { Formik } from 'formik';
import { AppInput, AppRemixIcon } from '@/layout/AppComponents';

export default function ZFSurveyUserAccessCode({
    loginValidationSchema,
    showBtnCheckCode,
    showBtnSignUpCode,
    isSignUp,
    message,
    status,
    error,
    onHandleSubmission,
    onHandleLogin,
}) {
    return (
        <div className="user-access-code-login">
            <h1>ENCUESTA DE MOVILIDAD SOSTENIBLE</h1>
            <div className="container">
                <div className="row">
                    <div className="col-12 mb-5">
                        <i>
                            <p>
                                Como parte de las obligaciones establecidas por la Ley de Movilidad Sostenible, todas las empresas debemos recopilar información sobre los desplazamientos del personal. Esta información nos permitirá mejorar las opciones de movilidad, facilitar medidas que os beneficien directamente y avanzar hacia un entorno de trabajo más sostenible y cómodo para toda la plantilla.
                            </p>
                            <p>
                                La encuesta no os llevará más de unos minutos y vuestras respuestas son esenciales para que podamos cumplir con la normativa y, sobre todo, para diseñar soluciones que se adapten realmente a vuestras necesidades.
                            </p>
                            <p>
                                <b>Instrucciones de acceso y uso</b>
                                <ol>
                                    <li>
                                        <u>Registro en la plataforma:</u> En la parte izquierda de la pantalla encontraréis la opción de registro. Deberéis introducir vuestro código de personal (ID).
                                    </li>
                                    <li>
                                        <u>Creación de contraseña:</u> Durante el registro, se os pedirá crear una contraseña. Esta deberá cumplir los siguientes requisitos:
                                        <ul>
                                            <li>
                                                Tener más de 8 caracteres
                                            </li>
                                            <li>
                                                Incluir al menos un número
                                            </li>
                                            <li>
                                                Incluir al menos un carácter especial (por ejemplo: !, @, #, etc.)
                                            </li>
                                            <li>
                                                Contener al menos una letra mayúscula
                                            </li>
                                            <li>
                                                Contener al menos una letra minúscula
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <u>Acceso a la encuesta:</u> Una vez completado el registro, podréis acceder desde la opción “Acceso”, situada en la parte derecha de la pantalla.
                                    </li>
                                </ol>
                            </p>
                        </i>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6 signup-block mb-5">
                        <Formik
                            initialValues={{
                                code: '',
                                password: '',
                                passwordConfirm: '',
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            onSubmit={onHandleSubmission}
                        >
                            {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
                                <form onSubmit={handleSubmit}>
                                    {isSignUp ? (
                                        <div className="signup-success-wrapper alert-success">
                                            <AppRemixIcon icon="check" />
                                            <div>Código registrado con éxito</div>
                                        </div>
                                    ) : (
                                        <div className="signup-wrapper">
                                            <label>Introduce tu ID de empleado para registrarte</label>
                                            <br />
                                            <span>
                                                En caso de tener problemas de acceso contacte con{' '}
                                                contacta con el responsable de tu empresa
                                            </span>
                                            <AppInput
                                                title="Código"
                                                value={values.code}
                                                error={errors.code}
                                                onChange={(v) => setFieldValue('code', v)}
                                            />
                                            {showBtnSignUpCode && (
                                                <>
                                                    <AppInput
                                                        title="Contraseña"
                                                        value={values.password}
                                                        error={errors.password}
                                                        onChange={(v) => setFieldValue('password', v)}
                                                        isPassword
                                                    />
                                                    <AppInput
                                                        title="Confirmar contraseña"
                                                        value={values.passwordConfirm}
                                                        error={errors.passwordConfirm}
                                                        onChange={(v) => setFieldValue('passwordConfirm', v)}
                                                        isPassword
                                                    />
                                                </>
                                            )}
                                            <button
                                                type="submit"
                                                className="btn btn-primary w-100"
                                                disabled={isSubmitting}
                                            >
                                                {showBtnCheckCode && 'Comprobar código'}
                                                {showBtnSignUpCode && 'Registrar código'}
                                            </button>
                                        </div>
                                    )}
                                </form>
                            )}
                        </Formik>
                    </div>
                    <div className="col-12 col-md-6">
                        <label>Acceso</label>
                        <Formik
                            initialValues={{
                                username: '',
                                password: '',
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            validationSchema={loginValidationSchema}
                            onSubmit={onHandleLogin}
                        >
                            {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
                                <form onSubmit={handleSubmit}>
                                    <AppInput
                                        title="Código"
                                        value={values.username}
                                        error={errors.username}
                                        onChange={(v) => setFieldValue('username', v)}
                                        autoFocus
                                    />
                                    <AppInput
                                        title="Password"
                                        value={values.password}
                                        error={errors.password}
                                        onChange={(v) => setFieldValue('password', v)}
                                        isPassword
                                    />
                                    <button
                                        type="submit"
                                        id="btn-login"
                                        name="login"
                                        className="btn btn-primary  w-100"
                                        disabled={isSubmitting}
                                    >
                                        Acceder
                                    </button>
                                    {error && <div className="alert alert-danger mt-3">{error}</div>}
                                </form>
                            )}
                        </Formik>
                        <div className="mt-2">
                            <i>
                                <b>
                                    Si tienes problema con el código o con la contraseña, por favor
                                    contacta con info@worldlex.net
                                </b>
                            </i>
                        </div>

                        <div className="mt-2">
                            <i>
                                *Protección de Datos: En esta plataforma no se registrarán datos
                                personales de ningún tipo.
                            </i>
                        </div>
                    </div>
                </div>
                {message && (
                    <div className="row">
                        <div className="col-12 mt-3">
                            <div
                                id="message"
                                className={`alert alert-${status === 'success' ? 'success' : 'danger'}`}
                            >
                                {message}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
